import React, { FC, ReactElement, useState } from 'react';
import classnames from 'classnames';
import { faFilter } from '@fortawesome/free-solid-svg-icons/faFilter';

import Button, { BUTTON_SIZES, BUTTON_TYPES } from 'buyside/components/presentation/Button/button';
import IndexFilterChips from 'buyside/components/presentation/IndexFilterChips/IndexFilterChips';
import StickyHeader from 'buyside/components/presentation/StickyHeader/stickyHeader';

import styles from './stickyFilterStyles.scss';

const StickyFilter: FC<{
  additionalElement?: ReactElement | null;
  children: ReactElement;
  isDarkTheme?: boolean;
  showMoreLess?: boolean;
}> = ({ additionalElement, children, isDarkTheme, showMoreLess }) => {
  const [isShowing, setIsShowing] = useState(false);

  return (
    <StickyHeader>
      {({ isSticky }: { isSticky: boolean }): ReactElement => (
        <div
          className={classnames(styles.wrapper, {
            [styles.sticky]: isSticky,
            [styles.darkTheme]: isDarkTheme
          })}
        >
          <IndexFilterChips />
          <div className={styles.container}>
            <div
              className={classnames(styles.filterContainer, {
                [styles.showFilter]: isShowing
              })}
            >
              {children}
            </div>
          </div>
          {showMoreLess && (
            <div className={styles.moreFiltersButtonContainer}>
              <Button
                faIcon={faFilter}
                type={BUTTON_TYPES.SECONDARY}
                text={isShowing ? 'Less Filters' : 'More Filters'}
                size={BUTTON_SIZES.TINY}
                onClick={(): void => setIsShowing(!isShowing)}
              />
              {additionalElement}
            </div>
          )}
        </div>
      )}
    </StickyHeader>
  );
};

export default StickyFilter;
